export default {
  en: "English",
  ru: "Русский",
  uk: "Українська",
  be: "Беларуская",
  lv: "latviešu valoda",
  cs: "čeština",
  de: "Deutsch",
  fr: "Français",
  it: "Italiano",
  sv: "Svenska",
  no: "Norsk",
  pt: "Português",
  hu: "Magyar",
  el: "ελληνικά",
  pl: "polski",
  nl: "Nederlands",
  ja: "日本語",
  th: "ไทย",
  ko: "한국어",
  zh: "中文, 汉语, 漢語",
  hi: "हिन्दी; हिंदी",
  es: "español",
  tr: "Türkçe",
  ar: "اَلْعَرَبِيَّةُ",
  az: "Azərbaycan dili",
};
